import { styled } from '@goodfynd/theme';

export const StyledCardContainer = styled('div', {
  padding: '0 1rem',
  width: '100%',
  '> .content': {
    padding: '1rem 0',
  },
});

export const StyledNumber = styled('span', {
  alignItems: 'center',
  backgroundColor: '$GreenBrand',
  borderRadius: '50%',
  color: '$Neutral00',
  display: 'flex',
  fontSize: '0.75rem',
  fontWeight: 800,
  height: '1.5rem',
  justifyContent: 'center',
  lineHeight: '1.125rem',
  minWidth: '1.5rem',
  width: '1.5rem',
});
